<div class="household-parent-grid" [formGroup]="formGroup">
  <div class="household-parent-header">
    <h5 class="household-section-title">Parent Information</h5>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="firstName" class="field-label">First name</label>
      <mat-form-field class="household-fields">
        <input id="firstName"
               matInput
               type="text"
               placeholder="First name"
               class="user-record-field-input"
               formControlName="firstName" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('firstName')" />
    </div>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="middleName" class="field-label">Middle name</label>
      <mat-form-field class="household-fields">
        <input id="middleName"
               matInput
               type="text"
               placeholder="Middle name"
               class="user-record-field-input"
               formControlName="middleName" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('middleName')" />
    </div>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="lastName" class="field-label">Last name</label>
      <mat-form-field class="household-fields">
        <input id="lastName"
               matInput
               type="text"
               placeholder="Last name"
               class="user-record-field-input"
               formControlName="lastName" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('lastName')" />
    </div>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="pidNumber" class="field-label">PID</label>
      <input
        id="pidNumber"
        matInput
        type="text"
        placeholder="PID"
        class="user-record-field-input"
        formControlName="pidNumber" />
    </div>
  </div>
  <div class="household-parent-field half-width">
    <div class="user-record-field-wrapper">
      <label for="birthDate" class="field-label">Parent Birth Date</label>
      <mat-form-field class="household-fields">
        <div class="user-record-datepicker-wrapper">
          <input id="birthDate"
                 matInput
                 [matDatepicker]="birthDatePicker"
                 placeholder="MM/DD/YYYY"
                 class="user-record-field-input"
                 formControlName="birthDate" 
                 readonly
                 (click)="birthDatePicker.open()"/>
          <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker startView="year"></mat-datepicker>
        </div>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('birthDate')" />
    </div>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="ssn" class="field-label">Parent Social Security</label>
      <lib-ssn-field
        id="ssn"
        [control]="ssnControl"
        [eyeButtonClass]="'eyeButtonClass'"
        [ariaErrorId]="formGroup.get('ssn')?.invalid && formGroup.get('ssn')?.touched ? 'ssn-error' : null">
      </lib-ssn-field>
      <cfi-form-inline-error [control]="formGroup.get('ssn')" />
    </div>
  </div>
</div>
